module.exports = __webpack_public_path__ + "media/dashboard/assets/images/arrow-down-short-73a5e81bf92c474bc4dae8740a2766aa.svg";